module.exports = __webpack_public_path__ + "static/media/copy_clippboard.a39f5499.svg";